export enum COMMUNITY_ADMIN {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=12240404
     */
    TEMPLATES = 'ADMIN.NAV.COMMUNITY_TEMPLATES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=73208919
     */
    DELETE_ONE_WITH_TITLE = 'ADMIN.COMMUNITIES.DELETE_ONE_WITH_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=73208921
     */
    DELETE_NB = 'ADMIN.COMMUNITIES.DELETE_NB',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=73208962
     */
    DELETE_NB_DESCRIPTION = 'ADMIN.COMMUNITIES.DELETE_NB.DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=12254214
     */
    DELETE_ONE = 'ADMIN.COMMUNITIES.DELETE_ONE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=12254221
     */
    DELETED_ONE = 'ADMIN.COMMUNITIES.DELETED_ONE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=12253240
     */
    DELETE_MULTIPLE = 'ADMIN.COMMUNITIES.DELETE_MULTIPLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=12253342
     */
    DELETED_MULTIPLE = 'ADMIN.COMMUNITIES.DELETED_MULTIPLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=65836463
     */
    SAVE_AS_TEMPLATE = 'COMMUNITIES_ADMIN.SAVE_AS_TEMPLATE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=65836464
     */
    NEW_COMMUNITY = 'COMMUNITIES_ADMIN.NEW_COMMUNITY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=51707497
     */
    SEARCH_NO_RESULTS = 'FRONT.COMMUNITY.SEARCH.NO_RESULTS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=67237420
     */
    NO_COMMUNITIES_DESCRIPTION = 'ADMIN.COMMUNITIES.NO_COMMUNITIES_DESCRIPTION',
}

enum SPACES_SPECIFIC_KEYS {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=242928352
     */
    DELETE_ONE_WITH_TITLE = 'SPACES.DELETE_ONE_WITH_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=242930041
     */
    DELETE_NB = 'SPACES.DELETE_NB',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=242935065
     */
    DELETE_NB_DESCRIPTION = 'SPACES.DELETE_NB.DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=242935127
     */
    DELETE_ONE = 'SPACES.DELETE_ONE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=242935185
     */
    DELETED_ONE = 'SPACES.DELETED_ONE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=242935291
     */
    DELETE_MULTIPLE = 'SPACES.DELETE_MULTIPLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=242935738
     */
    DELETED_MULTIPLE = 'SPACES.DELETED_MULTIPLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=242935809
     */
    NEW_COMMUNITY = 'SPACES.NEW_SPACE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=242944405
     */
    SEARCH_NO_RESULTS = 'SPACES.SEARCH_NO_RESULTS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=242944445
     */
    NO_COMMUNITIES_DESCRIPTION = 'SPACES.NO_SPACES_DESCRIPTION',
}

/** Getting spaces translate keys from space specific and community keys */
export const SPACES_ADMIN = { ...COMMUNITY_ADMIN, ...SPACES_SPECIFIC_KEYS };
